import { AnalyticalComponents } from '../components/modal/dashboard-goal-settings-modal/interfaces/analytical-components.enum';
import { CssWidths } from '../utils/css-widths.enum';

export class CheckBlock {
  public static getDefaultBlockConfiguration(): Array<CheckBlock> {
    return [
      new CheckBlock(
        true,
        AnalyticalComponents.MAIN_DASHBOARD_CHART,
        CssWidths.HUNDRED,
        'Revenue, receipts and customer graph'
      ),
      new CheckBlock(
        true,
        AnalyticalComponents.REVENUE_GOAL,
        CssWidths.THIRD,
        'Revenue goal component'
      ),
      new CheckBlock(
        true,
        AnalyticalComponents.RECEIPT_GOAL,
        CssWidths.THIRD,
        'Receipt goal component'
      ),
      new CheckBlock(
        true,
        AnalyticalComponents.CUSTOMER_GOAL,
        CssWidths.THIRD,
        'Customer goal component'
      )
    ];
  }

  constructor(
    public checked: boolean,
    public name: string,
    public width: string,
    public tooltip: string
  ) {}
}
